/* Escape Central — sticky Add-to-Cart bar. Vanilla, no deps. */
(function () {
  function init() {
    var bar = document.querySelector('[data-ec-satc]');
    if (!bar) return;

    // The main product form + its buttons/submit (Belliza uses .product-form__buttons / .product-form__submit)
    var form = document.querySelector('product-form form[action*="/cart/add"], form[action*="/cart/add"]');
    var buttonsWrap = document.querySelector('.product-form__buttons') || (form && form.querySelector('[type="submit"]'));
    var mainBtn = (form && form.querySelector('[name="add"], .product-form__submit, [type="submit"]')) ||
                  document.querySelector('.product-form__submit');
    if (!buttonsWrap || !mainBtn) return;

    var barBtn = bar.querySelector('[data-ec-satc-add]');
    var barLabel = bar.querySelector('[data-ec-satc-label]');
    var barPrice = bar.querySelector('[data-ec-satc-price]');

    function show() { bar.hidden = false; bar.setAttribute('aria-hidden', 'false'); requestAnimationFrame(function () { bar.classList.add('is-visible'); }); }
    function hide() { bar.classList.remove('is-visible'); bar.setAttribute('aria-hidden', 'true'); }

    // Show the bar once the main buttons have scrolled above the viewport
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        if (!e.isIntersecting && e.boundingClientRect.top < 0) show();
        else hide();
      }, { rootMargin: '0px', threshold: 0 });
      io.observe(buttonsWrap);
    }

    // Proxy click to the real add-to-cart button
    barBtn.addEventListener('click', function () { if (!mainBtn.disabled) mainBtn.click(); });

    // Mirror label + disabled state of the real button
    function sync() {
      var label = (mainBtn.querySelector('span') ? mainBtn.querySelector('span').textContent : mainBtn.textContent || '').trim();
      if (label && barLabel) barLabel.textContent = label;
      barBtn.disabled = mainBtn.disabled;
      barBtn.classList.toggle('is-disabled', mainBtn.disabled);
    }
    sync();
    new MutationObserver(sync).observe(mainBtn, { attributes: true, childList: true, subtree: true });

    // Mirror the live price from the PDP price block
    var priceEl = document.querySelector('.product-info .price, .product-data .price, .price__container, [data-product-price], .product-price');
    if (priceEl && barPrice) {
      var syncPrice = function () { var t = priceEl.textContent.replace(/\s+/g, ' ').trim(); if (t) barPrice.textContent = t; };
      syncPrice();
      new MutationObserver(syncPrice).observe(priceEl, { childList: true, subtree: true, characterData: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
